import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AllWeatherProtection from "./sections/AllWeatherProtection";
import TheDailyPlanetBriefing from "./sections/TheDailyPlanetBriefing";
import CoverageForEveryChapter from "./sections/CoverageForEveryChapter";
import TheProcess from "./sections/TheProcess";
import StudentBreakthroughs from "./sections/StudentBreakthroughs";
import SecureYourProtection from "./sections/SecureYourProtection";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AllWeatherProtection />
      <TheDailyPlanetBriefing />
      <CoverageForEveryChapter />
      <TheProcess />
      <StudentBreakthroughs />
      <SecureYourProtection />
      <Footer />
    </div>;
}